var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({ref:"navbar",class:[
    _vm.currentScroll > _vm.scrollTrigger ? 'navbar--threshold h-12' : 'navbar h-auto py-2',
    'fixed top-0 w-full flex justify-between items-center z-40'
  ],style:(_vm.navbarColor)},'div',_vm.$attrs,false),[_c('Container',{staticClass:"justify-between"},[_c('Logo',{class:[
        _vm.opacity.toString() === '1.0' ? 'h-8' : _vm.opacityMap[_vm.opacity],
        !_vm.opacity && 'h-12'
      ]}),_c('button',{staticClass:"outline-none focus:outline-none",attrs:{"name":'toggle-menu',"aria-label":"toggle-menu"},on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('font-awesome-icon',{staticClass:"white-text",attrs:{"icon":"fa-solid fa-bars","size":"lg"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }